module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "title_page"
    }
  }, [_vm._v("The Midas Murders")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Coat.tif",
      "src": "image/Coat_fmt.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_vm._v("Pieter Aspe")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Translated by Brian Doyle")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("For my daughters")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Tessa and Mira")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31ff7588","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/midas-1.vue
// module id = 69
// module chunks = 0